<div class="no-favorites">
  <img class="no-favorites-img" src="./assets/images/feedback/no-favorites.svg" alt="Start adding your favorites" />
  <p class="no-favorites-title">You haven't favorited any items yet</p>
  <p class="no-favorites-text">Please set at least one favorite item for us to display here.</p>
</div>
